import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {RateFieldType} from "@/components/business/crud/interface/FieldType";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'RateTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_a_rate = _resolveComponent("a-rate")!

  return (_openBlock(), _createBlock(_component_a_rate, {
    value: _ctx.data[_ctx.propName],
    tooltips: _ctx.widget.tips,
    "allow-half": _ctx.widget.half,
    count: _ctx.widget.count,
    disabled: ""
  }, null, 8, ["value", "tooltips", "allow-half", "count"]))
}
}

})